/**
 * Sidebar date-bucket grouping shared by ChatSidebar and AllThreadsSection.
 * Keep labels/order in sync across both.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

export const BUCKET_ORDER = [
	"Today",
	"Yesterday",
	"Last 7 days",
	"Last 30 days",
	"Older",
] as const;

export type DateBucket = (typeof BUCKET_ORDER)[number];

export function bucketFor(timestampMs: number): DateBucket {
	const now = Date.now();
	const startOfToday = new Date();
	startOfToday.setHours(0, 0, 0, 0);
	const todayMs = startOfToday.getTime();
	if (timestampMs >= todayMs) return "Today";
	if (timestampMs >= todayMs - DAY_MS) return "Yesterday";
	if (timestampMs >= now - 7 * DAY_MS) return "Last 7 days";
	if (timestampMs >= now - 30 * DAY_MS) return "Last 30 days";
	return "Older";
}
